import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

const client_id = import.meta.env.VITE_ENTRA_CLIENT_ID
const authority = import.meta.env.VITE_ENTRA_AUTHORITY
const redirectUri = import.meta.env.VITE_REDIRECT_URI


const msal_configuration = {
  auth: {
    clientId: client_id,
    authority: authority,
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
  }
};


export const loginRequest = {
  scopes: ["User.Read", "User.Read.All"] // delegated scopes
};


export const pca = new PublicClientApplication(msal_configuration);
